// src/pages/AdminOrderDetails.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

export default function AdminOrderDetails() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState({});

  useEffect(() => {
    async function fetchOrderAndProducts() {
      try {
        const res = await axios.get(`https://shophub-server.vercel.app/api/orders/${id}`);
        setOrder(res.data);

        // Fetch product details for images
        const productData = {};
        await Promise.all(res.data.items.map(async (item) => {
          const p = await axios.get(`https://shophub-server.vercel.app/api/products/${item.productId}`);
          productData[item.productId] = p.data;
        }));
        setProducts(productData);
      } catch (err) {
        console.error(err);
      }
    }

    fetchOrderAndProducts();
  }, [id]);

  if (!order) return <p className="text-center mt-10">Loading order details...</p>;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Order #{order._id}</h1>
      <div className="mb-4 space-y-1 text-sm">
        <p><strong>Status:</strong> {order.status}</p>
        <p><strong>Customer:</strong> {order.customer.name} ({order.customer.email})</p>
        <p><strong>Total:</strong> ${(order.totalAmount / 100).toFixed(2)}</p>
      </div>

      <h2 className="text-xl font-semibold mt-6 mb-3">Products</h2>
      <div className="space-y-4">
        {order.items.map((item, index) => {
          const product = products[item.productId];
          return (
            <div key={index} className="border rounded-lg flex items-center gap-4 p-4 bg-white shadow-sm">
              <img src={product?.image || ''} alt={item.name} className="w-20 h-20 object-contain bg-gray-100 rounded" />
              <div>
                <h3 className="text-lg font-medium">{item.name}</h3>
                <p>${(item.amount / 100).toFixed(2)} × {item.quantity}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
